const OBJECT_ID_RE = /^[0-9a-fA-F]{24}$/;

/**
 * Resolves a Media ID to a URL.
 * MongoDB ObjectIds are mapped directly to /api/media/file/:id (no round-trip needed).
 * Absolute URLs and paths are returned as-is.
 */
export const resolveMediaUrl = async (mediaIdOrUrl: string | undefined): Promise<string | null> => {
  if (!mediaIdOrUrl) return null;

  if (mediaIdOrUrl.startsWith('http://') || mediaIdOrUrl.startsWith('https://') || mediaIdOrUrl.startsWith('/')) {
    return mediaIdOrUrl;
  }

  if (OBJECT_ID_RE.test(mediaIdOrUrl)) {
    return `/api/media/file/${mediaIdOrUrl}`;
  }

  return null;
};

export const resolveMediaUrls = async (mediaIds: (string | undefined)[]): Promise<(string | null)[]> => {
  return Promise.all(mediaIds.map(id => resolveMediaUrl(id)));
};

